"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInstanceId = exports.getObjFromInstance = exports.createInstance = exports.Service = exports.RequestService = exports.AppService = exports.onInit = exports.delegateInit = exports.EnumFactoryModuleType = void 0;
require("reflect-metadata");
var QueueCallFun_1 = require("../BaseModule/QueueCallFun");
var utils_1 = require("../utils");
var const_1 = require("./const");
/**
 * 定义模块类型
 */
var EnumFactoryModuleType;
(function (EnumFactoryModuleType) {
    /** 应用程序级别，在一个应用程序内只有一个object对象 */
    EnumFactoryModuleType[EnumFactoryModuleType["AppService"] = 1] = "AppService";
    /** 请求级别，每次发起请求将会创建一个新的object对象，并在请求结束释放 */
    EnumFactoryModuleType[EnumFactoryModuleType["RequestService"] = 2] = "RequestService";
    /** 当超过一个应用程序在运行的时候全局只有一个object对象 */
    EnumFactoryModuleType[EnumFactoryModuleType["GlobalService"] = 3] = "GlobalService";
})(EnumFactoryModuleType = exports.EnumFactoryModuleType || (exports.EnumFactoryModuleType = {}));
var instancePool = {};
var classPool = [];
var globalObjPool = {};
var defineFactoryService = function (Target, type) {
    var typeName = (EnumFactoryModuleType)[type];
    var uid = typeName + "_" + utils_1.utils.guid();
    var checkType = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_TYPE, Target);
    if (utils_1.utils.isEmpty(checkType)) {
        Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_TYPE, type, Target);
        Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_CLASSID, uid, Target);
        classPool.push(Target);
    }
    else {
        if (checkType !== type) {
            throw new Error("\u591A\u4E2A\u5B9A\u4E49\u6A21\u5757\u7C7B\u578B\u88C5\u9970\u5668\u4E0D\u80FD\u540C\u65F6\u4F7F\u7528.(" + typeName + ")");
        }
    }
};
var invokeInit = function (Target, obj) {
    var initCallbacks = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INIT, Target) || [];
    // const instanceId = Reflect.getMetadata(CONST_DECORATOR_FOR_MODULE_INSTANCEID, Target);
    var index = 0;
    if (initCallbacks.length > 0) {
        QueueCallFun_1.queueCallFunc(initCallbacks, function (opt, fn) {
            return fn(obj, opt);
        }, {
            throwException: false,
            paramConvert: function (fn) {
                index += 1;
                return {
                    id: "init_" + index,
                    params: fn
                };
            }
        }).then(function () {
            var initData = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_ON_INIT, obj);
            if (initData) {
                initData.callback.apply(obj, initData.args || []);
            }
        }).catch(function (err) {
            throw err;
        });
    }
};
var delegateInit = function (fn) {
    return function (Target) {
        var initCallbacks = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INIT, Target) || [];
        initCallbacks.push(fn);
        Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INIT, initCallbacks, Target);
    };
};
exports.delegateInit = delegateInit;
var onInit = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (target, attr, value) {
        Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_ON_INIT, {
            args: args,
            callback: value.value,
            name: attr
        }, target);
    };
};
exports.onInit = onInit;
var AppService = function (Target) {
    defineFactoryService(Target, EnumFactoryModuleType.AppService);
};
exports.AppService = AppService;
var RequestService = function (Target) {
    defineFactoryService(Target, EnumFactoryModuleType.RequestService);
};
exports.RequestService = RequestService;
var Service = function (Target) {
    defineFactoryService(Target, EnumFactoryModuleType.GlobalService);
};
exports.Service = Service;
var createInstance = function (Factory, instanceId, callback) {
    var instanceAppId = instanceId || "app_" + utils_1.utils.guid();
    var paramTypes = Reflect.getMetadata("design:paramtypes", Factory) || [];
    // -------
    var classType = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_TYPE, Factory);
    var classId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_CLASSID, Factory);
    var instance, shouldInit = false;
    if (!instancePool[instanceAppId]) {
        instancePool[instanceAppId] = {};
    }
    /** Before init params should bind instance id, make sure the inject module can got the id */
    Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, instanceAppId, Factory);
    var paramsInstance = paramTypes.map(function (Fn) {
        var classType = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_TYPE, Fn);
        if (utils_1.utils.isEmpty(classType)) {
            throw new Error(Fn.name + "\u6CA1\u6709\u6CE8\u518C");
        }
        else {
            var classType_1 = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_TYPE, Fn);
            if (classType_1 === EnumFactoryModuleType.GlobalService) {
                var objId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_CLASSID, Fn);
                if (globalObjPool[objId]) {
                    return globalObjPool[objId];
                }
                else {
                    return exports.createInstance(Fn, instanceAppId, callback);
                }
            }
            else if (classType_1 === EnumFactoryModuleType.RequestService) {
                return exports.createInstance(Fn, instanceAppId, callback);
            }
            else if (classType_1 === EnumFactoryModuleType.AppService) {
                var objId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_CLASSID, Fn);
                if (instancePool[instanceAppId] && instancePool[instanceAppId][objId]) {
                    return instancePool[instanceAppId][objId];
                }
                else {
                    if (!instancePool[instanceAppId]) {
                        instancePool[instanceAppId] = {};
                    }
                    var obj = exports.createInstance(Fn, instanceAppId, callback);
                    instancePool[instanceAppId][objId] = obj;
                    return obj;
                }
            }
            else {
                return new Fn();
            }
        }
    });
    if (classType === EnumFactoryModuleType.GlobalService) {
        if (globalObjPool[classId]) {
            instance = globalObjPool[classId];
        }
        else {
            instance = new (Factory.bind.apply(Factory, __spreadArray([void 0], paramsInstance)))();
            shouldInit = true;
            globalObjPool[classId] = instance;
        }
    }
    else if (classType === EnumFactoryModuleType.RequestService) {
        var reqInitEvent = {
            args: paramsInstance,
            shouldInit: false,
            classType: classType,
            uid: classId
        };
        instance = typeof callback === "function" ? callback(Factory, reqInitEvent) : null;
        shouldInit = reqInitEvent.shouldInit;
        if (!instance) {
            throw new Error("Failed to initialize request factory");
        }
    }
    else if (classType === EnumFactoryModuleType.AppService) {
        if (instancePool[instanceAppId][classId]) {
            instance = instancePool[instanceAppId][classId];
        }
        else {
            instance = new (Factory.bind.apply(Factory, __spreadArray([void 0], paramsInstance)))();
            instancePool[instanceAppId][classId] = instance;
            shouldInit = true;
        }
    }
    else {
        var reqInitEvent = {
            args: paramsInstance,
            shouldInit: false,
            classType: classType,
            uid: classId
        };
        instance = typeof callback === "function" ? callback(Factory, reqInitEvent) : null;
        shouldInit = reqInitEvent.shouldInit;
        if (!instance) {
            instance = Factory;
        }
    }
    Reflect.defineMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, instanceAppId, instance);
    shouldInit && invokeInit(Factory, instance);
    return instance;
};
exports.createInstance = createInstance;
var getObjFromInstance = function (Target, instance, callback) {
    var instanceId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, instance) ||
        Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, instance.constructor);
    var targetObj = exports.createInstance(Target, instanceId, callback);
    return targetObj;
};
exports.getObjFromInstance = getObjFromInstance;
var GetInstanceId = function (target, attrKey) {
    Object.defineProperty(target, attrKey, {
        configurable: false,
        enumerable: true,
        get: function () {
            var instanceId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, target) ||
                Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, target.constructor);
            return instanceId;
        }
    });
};
exports.GetInstanceId = GetInstanceId;
